export default __webpack_public_path__ + "static/media/Novelties_Dark.9674a4d7.svg";